<script>
  import { Input, Label } from "sveltestrap";
  import { data, dataInfo, currentSpec } from "../../editor/storage.js";
  import Table from "./table.svelte";
  import { makeFilterFunction } from "../../fronto/utility.js";
  import { validateFilter as vf } from "../../editor/component/dataTransform.js";
  import { Item } from "../../vg/vega.js";
  import ItemResponse from "./ItemResponse.svelte";
  import { deepcopy } from "../../editor/utility.js";
  export let closer;
  export let inputBlurAction;
  export let inputFocusAction;
  export let changeAction;
  export let value;
  export let specifiedLayer;
  let exprValue = value?.expression || "";
  let as = value?.as || "newOp";
  let previewData = $data,
    previewColumns = deepcopy($dataInfo.columns);
  let expressionForm, isProcessing, isProcessingError, asForm;
  let mode = "expr";
  function updatePreview(role, event) {
    let expr = role === "expr" ? event.target.value : exprValue,
      name = role === "name" ? event.target.value : as;
    isProcessing = true;
    isProcessingError = false;
    if (vf(expr)) {
      let fObj = mode === "JSON" ? JSON.parse(expr) : expr;
      previewData = $data.map((d) => {
        let nd = deepcopy(d);
        nd[name] = makeFilterFunction(fObj, true)(d);
        return nd;
      });
      previewColumns = deepcopy($dataInfo.columns);
      previewColumns.push(name);
      console.log(previewData, previewColumns);
    } else {
      previewData = [];
      isProcessingError = true;
    }
    isProcessing = false;
  }
  function insertToExpression(v, v2) {
    if (expressionForm?.selectionStart !== undefined) {
      let ps = expressionForm.selectionStart;
      let pe = expressionForm.selectionEnd;
      if (v2) {
        exprValue =
          exprValue.substring(0, ps) +
          v +
          exprValue.substring(ps, pe || ps) +
          v2 +
          exprValue.substring(pe || ps, exprValue.length);
      } else {
        exprValue =
          exprValue.substring(0, ps) +
          v +
          exprValue.substring(pe || ps, exprValue.length);
      }
    } else {
      exprValue += v;
    }
    expressionForm?.focus();
  }

  let currSpecLayerNames = [],
    currSpecLayers = [];
  currentSpec.subscribe((spec) => {
    currSpecLayers = spec.fronto.layer?.map((l) => l.name) || [];
    currSpecLayerNames =
      spec.fronto.layer?.map(
        (l) => l.name + (l.mark?.type ? " / " + l.mark?.type : "")
      ) || [];
    currSpecLayers.splice(0, 0, "None");
    currSpecLayerNames.splice(0, 0, undefined);
  });
</script>

<div class="window-background">
  <div class="window">
    <div class="window-header">
      <h3>Edit calculate expression</h3>
      <button type="button" on:click={closer}>
        <i class="bi bi-x" alt="cancel" />
      </button>
    </div>
    <div class="window-body">
      <p class="text-sm mb-2 px-3">
        Double-click data fields and operators to insert them in the experssion.
        An expression should be in a Vega expression format.
      </p>
      <div class="columns">
        <!-- main -->
        <div class="section-main">
          <div class="dupo-menu-pane">
            <div class="dupo-menu-pane-row">
              <Label for="_expression">Expression</Label>
            </div>
            <div class="dupo-menu-pane-form-row">
              <textarea
                type="textarea"
                class="custom-form-select"
                name="_expression"
                id="_expression"
                style="height: 11.5rem; font-family: var(--bs-font-monospace);"
                bind:this={expressionForm}
                bind:value={exprValue}
                on:focus={(event) => {
                  inputFocusAction(event);
                  updatePreview("expr", event);
                }}
                on:blur={inputBlurAction}
                on:keyup={(event) => {
                  updatePreview("expr", event);
                }}
              />
            </div>
          </div>
          <div class="dupo-menu-pane">
            <div class="dupo-menu-pane-row">
              <Label for="-as">New field name (as)</Label>
            </div>
            <div class="dupo-menu-pane-form-row">
              <Input
                type="text"
                class="custom-form-select"
                name="-as"
                id="-as"
                bind:this={asForm}
                bind:value={as}
                on:focus={(event) => {
                  inputFocusAction(event);
                  updatePreview("name", event);
                }}
                on:blur={inputBlurAction}
                on:keyup={(event) => {
                  updatePreview("name", event);
                }}
              />
            </div>
          </div>
          <div class="dupo-menu-pane">
            <div class="dupo-menu-pane-row pt-2">
              <Label>Data preview</Label><span
                class={"ms-2 preview" +
                  (isProcessing
                    ? " processing"
                    : isProcessingError
                    ? " error"
                    : "")}
                >{isProcessing
                  ? "Processing..."
                  : isProcessingError
                  ? "Error"
                  : "Done"}</span
              >
            </div>
            <div class="dupo-menu-pane-row">
              <div class="data-previewer form-style">
                <Table tableData={previewData} tableColumns={previewColumns} />
              </div>
            </div>
          </div>
        </div>
        <!-- operators -->
        <div class="section-operators">
          <div class="dupo-menu-pane mb-2">
            <div class="dupo-menu-pane-row">
              <Label>Data fields</Label>
            </div>
            <div class="dupo-menu-pane-row">
              <div
                class="form-style py-2"
                style="height: 6rem; overflow-y: scroll"
              >
                {#each $dataInfo.columns as c}
                  <!-- <div class="column-name-wrap"> -->
                  <span
                    class="field-name"
                    on:dblclick={() => {
                      insertToExpression(
                        mode === "JSON" ? `{"${c}": }` : `datum.${c}`
                      );
                    }}
                  >
                    {c}
                  </span>
                  <!-- </div> -->
                {/each}
              </div>
            </div>
          </div>

          <div class="dupo-menu-pane mb-2">
            <div class="dupo-menu-pane-row">
              <Label>Operators</Label>
            </div>
            <div class="dupo-menu-pane-row">
              <div
                class="form-style pt-2"
                style="height: 16rem; overflow-y: scroll;"
              >
                <!-- "eq" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(mode === "JSON" ? `{"eq": }` : "==");
                    }}>eq</span
                  ><span class="operator-desc">Eqaul to.</span>
                </div>
                <!-- "neq" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(mode === "JSON" ? `{"neq": }` : "!=");
                    }}>neq</span
                  ><span class="operator-desc">Not equal to.</span>
                </div>
                <!-- "leq" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(mode === "JSON" ? `{"leq": }` : "<=");
                    }}>leq</span
                  ><span class="operator-desc">Less than or equal to.</span>
                </div>
                <!-- "geq" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(mode === "JSON" ? `{"geq": }` : ">=");
                    }}>geq</span
                  ><span class="operator-desc">Greater than or equal to.</span>
                </div>
                <!-- "lt" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(mode === "JSON" ? `{"lt": }` : "<");
                    }}>lt</span
                  ><span class="operator-desc">Less than.</span>
                </div>
                <!-- "gt" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(mode === "JSON" ? `{"gt": }` : ">");
                    }}>gt</span
                  ><span class="operator-desc">Greater than.</span>
                </div>
                <!-- "range" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        mode === "JSON" ? `{"range": [, ]}` : "<= && =<"
                      );
                    }}>range(A, B)</span
                  ><span class="operator-desc">Between/equal to A and B.</span>
                </div>
                <!-- "xrange" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        mode === "JSON" ? `{"xrange": [, ] }` : "< && >"
                      );
                    }}>xrange(A, B)</span
                  ><span class="operator-desc">Within A and B.</span>
                </div>
                <!-- "startsWith" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        mode === "JSON"
                          ? `{"startsWith": ""}`
                          : `startsWith(, '')`
                      );
                    }}>startsWith(X)</span
                  ><span class="operator-desc">Starts with X</span>
                </div>
                <!-- "endsWith" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        mode === "JSON" ? `{"endsWith": ""}` : `endsWith(, '')`
                      );
                    }}>endsWith(X)</span
                  ><span class="operator-desc">Ends with X</span>
                </div>
                <!-- "startsEndsWith" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        mode === "JSON"
                          ? `{"startsEndsWith": ["", ""]}`
                          : `startsEndsWith(, '', '')`
                      );
                    }}>startsEndsWith(A, B)</span
                  ><span class="operator-desc"
                    >Starts with A and ends with B</span
                  >
                </div>
                <!-- "includes" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        mode === "JSON" ? `{"includes": ""}` : `includes(, '')`
                      );
                    }}>includes(X)</span
                  ><span class="operator-desc">Includes X</span>
                </div>
                <!-- "pattern" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        mode === "JSON" ? `{"pattern": ""}` : `pattern(, //g)`
                      );
                    }}>pattern</span
                  ><span class="operator-desc">Matches a RegEx pattern.</span>
                </div>
                <!-- "oneOf" -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        mode === "JSON" ? `{"oneOf": []}` : `oneOf(, [])`
                      );
                    }}>oneOf</span
                  ><span class="operator-desc">Is one of the values.</span>
                </div>
              </div>
            </div>
          </div>

          {#if $currentSpec}
            <div class="dupo-menu-pane mb-2">
              <div class="dupo-menu-pane-row">
                <ItemResponse
                  type="select"
                  token="layer-specific"
                  title={"Apply to a specific layer"}
                  inputBlurAction
                  inputFocusAction
                  value={specifiedLayer}
                  options={currSpecLayers}
                  optionNames={currSpecLayerNames}
                  changeAction={(event) => {
                    specifiedLayer = event.target.value;
                  }}
                />
              </div>
            </div>
          {/if}
        </div>
      </div>

      <div class="pane-divider" />

      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-button-row">
          <button
            type="button"
            disabled={!as || as.length == 0}
            on:click={(event) => {
              closer();
              if (changeAction) {
                changeAction({
                  target: { value: exprValue, as, layer: specifiedLayer },
                });
              }
            }}><i class="bi bi-check-lg me-1" /> Confirm</button
          >
          <button type="button" on:click={closer}
            ><i class="bi bi-x-lg me-1" /> Cancel</button
          >
        </div>
      </div>
    </div>
  </div>
</div>

<!-- {#if invalidFilter}
<div class="dupo-menu-pane-row warn-msg">
  <p class="description">
    <i class="bi bi-exclamation me-1" />Invalid filter expression
  </p>
</div>
{/if} -->
<style>
  .window-background {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 999;
  }
  .window {
    position: absolute;
    top: 120px;
    left: 50%;
    transform: translateX(-50%);
    width: 95vw;
    max-width: 1000px;
    height: auto;
    background-color: white;
    border: 1px solid #dddddd;
    border-radius: var(--default-radius);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1), 0 7px 25px rgba(0, 0, 0, 0.1);
  }
  .window-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 2rem 0 2rem;
  }
  .window-header h3 {
    font-size: 1rem;
    color: #454545;
    margin: 0;
    padding: 0;
    user-select: none;
  }
  .window-header button {
    appearance: none;
    padding: 0;
    margin: 0;
    border: 0;
    font-size: 1rem;
    background: transparent;
  }
  .window-body {
    padding: 1rem;
  }

  .columns {
    display: flex;
    flex-wrap: wrap;
  }
  .section-main {
    width: 75%;
  }
  .section-operators {
    width: 25%;
  }
  .data-previewer {
    height: 13.5rem;
    overflow-y: scroll;
  }
  .form-style {
    width: calc(100% + 1rem);
    padding: 0.2rem 0.5rem;
    margin: 0 -0.5rem;
    border-radius: var(--default-radius);
    background-color: white;
    border: 1px solid #dddddd;
    font-size: 0.8rem;
  }
  .field-name {
    display: inline-block;
    color: #454545;
    background-color: #f5f5f5;
    padding: 0.2rem 0.5rem;
    border-radius: var(--default-radius);
    margin: 0 0.5rem 0.25rem 0;
    font-size: 0.72rem;
    font-family: var(--bs-font-monospace);
  }
  .field-name:hover {
    color: #009aa1;
    background-color: #dff8f8;
  }
  .operator-wrap {
    margin: 0 0 0.5rem 0;
  }
  .operator {
    display: inline;
    color: #454545;
    background-color: #f5f5f5;
    padding: 0.2rem 0.5rem;
    border-radius: var(--default-radius);
    margin: 0 0.5rem 0.25rem 0;
    font-size: 0.72rem;
    font-family: var(--bs-font-monospace);
  }
  .operator:hover {
    color: #f47100;
    background-color: #fff2df;
  }
  .operator-desc {
    display: inline-block;
    font-size: 0.7rem;
    margin: 0 0.5rem 0.25rem 0;
  }
  .preview {
    display: inline;
    color: #1945cf;
    background-color: #e2f3ff;
    padding: 0.2rem 0.5rem;
    border-radius: var(--default-radius);
  }
  .preview.processing {
    color: #454545;
    background-color: #f5f5f5;
  }
  .preview.error {
    color: #d00000;
    background-color: #ffe9eb;
  }
</style>
